import { render } from "./Funding.vue?vue&type=template&id=0a75e218&scoped=true"
import script from "./Funding.vue?vue&type=script&lang=js"
export * from "./Funding.vue?vue&type=script&lang=js"

import "./Funding.vue?vue&type=style&index=0&id=0a75e218&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a75e218"]])

export default __exports__